import { getSearchLocalizedValue, getSearchJoinedLocalizedValues } from "./get-search-localized-value.js";
const createAltTag = (variant, locale, labels) => {
  const brand = variant.brand || "";
  const accessoireType = getSearchLocalizedValue(variant, "accessoryType", locale);
  const accessoireColor = getSearchJoinedLocalizedValues(variant, "accessoryColor", locale);
  const frameColor = getSearchJoinedLocalizedValues(variant, "frameColor", locale) ?? "";
  const lensColor = getSearchLocalizedValue(variant, "lensColor", locale) ?? "";
  const replacementFrequency = getSearchLocalizedValue(variant, "replacementFrequency", locale);
  const solutionType = variant.solutionType?.toString().replace("Eye drops", "");
  const packageOption = variant.packageOption;
  const colorsLabel = [lensColor, frameColor].filter((s) => s.trim() !== "").join(" / ");
  const packageQuantity = variant.packageQuantity;
  const packageQuantityLabel = packageQuantity && `${packageQuantity} ${packageQuantity === 1 ? labels.lens : labels.lenses} ${labels.perBox}`;
  return [
    brand,
    variant.name,
    solutionType,
    packageOption,
    replacementFrequency,
    packageQuantityLabel,
    colorsLabel,
    accessoireType,
    accessoireColor
  ].filter(Boolean).filter((entry) => entry != "").join(" ");
};
export {
  createAltTag
};
//# sourceMappingURL=create-alt-tag.js.map
